import { useTranslation } from 'react-i18next';

type UseDraggableItemsListParams = {
  disableDrag?: boolean;
  disableEditMode?: boolean;
  dragHandleAriaLabel?: string;
};

export type UseDraggableItemsListReturn = {
  dragHandleLabel: string;
  isDragDisabled: boolean;
};

function useDraggableItemsList({
  disableDrag = false,
  disableEditMode = true,
  dragHandleAriaLabel,
}: UseDraggableItemsListParams): UseDraggableItemsListReturn {
  const { t } = useTranslation();

  const isDragDisabled = disableEditMode || disableDrag;

  // Escape hatch de contexto (p. ej. "reordenar módulos" vs "reordenar
  // contenidos"); por defecto usa la clave genérica del DS.
  const dragHandleLabel = dragHandleAriaLabel ?? t('common:DragToReorder');

  return { dragHandleLabel, isDragDisabled };
}

export default useDraggableItemsList;
